import {AfterViewInit, Component, EventEmitter, OnInit, Output} from '@angular/core';
import {NewAlertService} from 'src/app/shared/components/new-alert/new-alert.service';
import {ParametrosDataService} from 'src/app/services/parametros-data.service';
import {ApiError} from 'src/app/shared/enums/api-error.enum';
import {Auth} from 'src/app/models/auth';
import {AuthenticationService} from 'src/app/services/authentication.service';
import {TutorialService} from 'src/app/services/tutorial.service';
import {Tutorial, TutorialProgresso} from '../../../models/tutorial';
import {TourService} from 'ngx-tour-md-menu';
import {ResponseBase} from '../../../models/response-base';
import {PassosTutorial} from '../../../shared/enums/passosTutorial.enum';
import { CardNameBroadcastServiceService } from 'src/app/services/card-name-broadcast-service.service';
import { CedenteService } from 'src/app/services/cedente.service';
import { GestorService } from 'src/app/services/gestor.service';
import { ProdutoService } from 'src/app/services/produto.service';
import { CollaboratorTypeService } from 'src/app/services/collaborator-type.service';

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit, AfterViewInit {

    @Output() finishedLoading: EventEmitter<boolean> = new EventEmitter<boolean>();

    public tutorial: Tutorial;
    public passos: any;
    private currentUser: Auth;
    public nomeUsuario = '';
    public autorizar = false;

    public progresso: TutorialProgresso;
    hasLoaded: boolean = false;


    constructor(
        private alertService: NewAlertService,
        private parametrosDataService: ParametrosDataService,
        private tutorialService: TutorialService,
        public tourService: TourService,
        private cedenteService: CedenteService,
        private authenticationService: AuthenticationService,
        private gestorService: GestorService,
        private produtoService: ProdutoService,
        private authService: AuthenticationService,
        private collaboratorType: CollaboratorTypeService
    ) {


    }

    ngOnInit() {
        this.currentUser = this.authenticationService.currentUserValue;
        // this.progresso = new TutorialProgresso();
        /*this.cedenteService
            .getInfo(
                this.currentUser.token.assignorGuid,
                this.currentUser.token.userReferenceId
            )
            .subscribe(response => {
                if (response.status === ApiError.Sucesso) {
                    this.nomeUsuario = response.result.apelido;
                } else {
                    this.alertService.error(response.message);
                }
            });*/

        this.cedenteService.getAuthAssignorInfo(this.currentUser.token.assignorGuid)
        .subscribe(
            response =>{
                if(response.status == ApiError.Sucesso){
                    this.currentUser.token.pessoaId = response.result.pessoaId;
                    this.currentUser.token.accountId = response.result.contaGuid;
                    this.nomeUsuario = response.result.apelido;
                    sessionStorage.setItem('cedenteId', JSON.stringify(response.result.id))
                    this.authService.setCurrentUserValue(this.currentUser);
                    this.hasLoaded = true;
                }
            }
        )

        // this.tutorialService.getProgresso(this.currentUser.token.assignorGuid, this.currentUser.token.userReferenceId, 'homeCedente').subscribe((response: ResponseBase<TutorialProgresso>) => {
        //     if (response.status == ApiError.Sucesso) {
        //         this.progresso = response.result;

        //         if (this.progresso.progresso < 100) {
        //             this.autorizar = true;
        //             this.passos = this.tutorialService.getLocalStoragePassos;


        //             if (!this.passos) {
        //                 this.tutorialService.getTutorial('homeCedente').subscribe(
        //                     resp => {
        //                         if (resp.status == ApiError.Sucesso) {
        //                             this.tutorial = resp.result;
        //                             this.tutorial.passos.forEach(e => {
        //                                 //console.log('asdoiasdjoiasj' + e.idBotaoAcao);
        //                                 if (e.idBotaoAcao === -1) {
        //                                     e.headerModal = 'Olá! ' + this.nomeUsuario;
        //                                     e.ordemAtividade = 1;
        //                                 }
        //                             });
        //                             this.tutorialService.setLocalStorageTutorial(this.tutorial);
        //                             this.passos = this.tutorialService.createStepsTutorial(this.tutorial);
        //                             this.tutorialService.setLocalStoragePassos(this.passos);
        //                             this.tourService.initialize(this.passos);
        //                             this.getPasso(this.progresso.progresso);
        //                         }
        //                     }
        //                 );
        //             } else {
        //                 this.tourService.initialize(this.passos);
        //                 this.getPasso(this.progresso.progresso);
        //             }
        //         } else {
        //             this.autorizar = true;
        //         }
        //     }
        // }, error => {
        //     console.log(error);

        // });

        this.gestorService.getGestor(this.currentUser.token.userReferenceId, this.currentUser.token.assignorGuid)
        .subscribe(response => {
            if (response.status === ApiError.Sucesso) {
                sessionStorage.setItem('gestorCedente', JSON.stringify(response.result.gestor))
            }
        });
        /*this.gestorService.getAll(this.currentUser.token.assignorGuid).subscribe(
            response => {
                if (response.status === ApiError.Sucesso) {
                    sessionStorage.setItem('cedenteId', JSON.stringify(response.result[0].cedenteId))
                }
            }
        );*/

        this.getProductsCategory();

        this.getCollaboratorType();
    }

    ngAfterViewChecked(){

        // you could also do this after a service call of some sort
        this.finishedLoading.emit(true);
    }

    private getPasso(progresso: number) {
        switch (progresso) {
            case 0:
                this.tourService.startAt(PassosTutorial.inicio);
                break;
            case 20:
                this.tourService.startAt(PassosTutorial.barraProgresso);
                break;
            case 40:
                this.tourService.startAt(PassosTutorial.aderirBeneficio);
                break;
            case 60:
                this.tourService.startAt(PassosTutorial.cadastrarColaborador);
                break;
            case 80:
                this.tourService.startAt(PassosTutorial.cadastrarPedido);
                break;
            case 100:
                this.tourService.end();
                break;
            default:
                this.tourService.startAt(PassosTutorial.inicio);
                break;
        }
    }

    getProductsCategory(){
        this.produtoService.getProductsCategory().subscribe(
            res => {
                if(res.status == ApiError.Sucesso){
                    localStorage.setItem('productCategory', JSON.stringify(res.result));
                }
            }
        )
    }

    getCollaboratorType(){
        this.collaboratorType.get().subscribe(
            res => {
                if(res.status == ApiError.Sucesso){
                    localStorage.setItem('collaboratorType', JSON.stringify(res.result));
                }
            }
        )
    }


    ngAfterViewInit(): void {
    }


}
